import React, { useState, useEffect } from "react";
import "./rules.css";
import { Link, useNavigate } from "react-router-dom";
import defaultLogo from "../../img/logo.png";
import MonkeyBackdrop from "../../components/MonkeyBackdrop";
import { useBrandCtaVars } from "../../hooks/useBrandCtaVars";

/** Shown when `userData.rules` is missing or empty */
const DEFAULT_RULES = [
  "Write 3 statements about yourself",
  "Make 1 of them a lie",
  "Others try to spot your lie",
  "Guess the lie in other's turns",
  "Fool them or catch the bluff to score points"
];

function parseRules(val) {
  if (Array.isArray(val)) return val.filter(Boolean);
  if (typeof val === "string") {
    try {
      const p = JSON.parse(val);
      return Array.isArray(p) ? p.filter(Boolean) : [];
    } catch {
      return [];
    }
  }
  return [];
}

function Rules({ updateHeader }) {
  const navigate = useNavigate();
  const [topLogo, setTopLogo] = useState(defaultLogo);
  const [userData, setUserData] = useState(null);
  const [rules, setRules] = useState(DEFAULT_RULES);
  const [textcolor, Setcolorcode] = useState(null);

  useEffect(() => {
    const storedSession = sessionStorage.getItem("userData");
    if (!storedSession) {
      navigate("/login");
      return;
    }

   
    // eslint-disable-next-line react-hooks/exhaustive-deps -- updateHeader identity varies by parent
  }, [navigate]);

  
  useEffect(() => {
    updateHeader({
      backButtonRedirect: "/intro",
      // ...(companyLogo ? { imageUrl: companyLogo } : {}),
    });
  }, []);

  const { style: ctaVars, themed: ctaThemed } = useBrandCtaVars(userData, topLogo);

  const titleColor = textcolor || undefined;

  return (
    <div className="rules-page">
      <MonkeyBackdrop />
      <main className="rules-page__main">

        <h1 className="rules-page__title" style={{ color: titleColor }} id="introtext">
        <span>🎮</span>
        How to Play
        </h1>
        
        <div className="rules-page__box">
          <ul className="rules-page__card">
            {rules.map((rule, index) => (
              <li className="rules-page__rule" key={index}>
                {rule || "N/A"}
              </li>
            ))}
          </ul>

          <div className="rules-page__actions">
            <Link
              to="/userpage"
              className={ctaThemed ? "begin-play-btn begin-play-btn--themed" : "begin-play-btn"}
              style={ctaThemed ? ctaVars : undefined}
            >
              Next
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Rules;
